"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var login_guard_service_1 = require("../../services/login-guard.service");
var navigation_component_1 = require("./navigation.component");
var core_1 = require("@angular/core");
var idm_authorization_client_js_1 = require("@synisys/idm-authorization-client-js");
var pin_unpin_service_1 = require("./api/pin-unpin.service");
var pin_unpin_service_impl_1 = require("../../services/pin-unpin.service.impl");
var sis_nav_bar_component_1 = require("./nav-bar/sis-nav-bar.component");
var sis_nav_bar_group_component_1 = require("./nav-bar/sis-nav-bar-group.component");
var sis_nav_bar_item_component_1 = require("./nav-bar/sis-nav-bar-item.component");
var sis_nav_bar_section_component_1 = require("./nav-bar/sis-nav-bar-section.component");
var shared_module_1 = require("../shared.module");
var router_1 = require("@angular/router");
var navigation_item_title_handler_service_1 = require("./navigation-item-title-handler.service");
var nav_message_pipe_1 = require("./nav-message.pipe");
/**
 * Created by Hayk.Andriasyan on 10/16/2017.
 */
var ShellNavigationBlockModule = /** @class */ (function () {
    function ShellNavigationBlockModule() {
    }
    ShellNavigationBlockModule = __decorate([
        core_1.NgModule({
            imports: [shared_module_1.SharedModule, router_1.RouterModule],
            declarations: [
                navigation_component_1.NavigationComponent,
                sis_nav_bar_component_1.SisNavBarComponent,
                sis_nav_bar_group_component_1.SisNavBarGroupComponent,
                sis_nav_bar_item_component_1.SisNavBarItemComponent,
                sis_nav_bar_section_component_1.SisNavBarSectionComponent,
                nav_message_pipe_1.NavMessagePipe
            ],
            exports: [
                navigation_component_1.NavigationComponent,
                sis_nav_bar_component_1.SisNavBarComponent,
                sis_nav_bar_group_component_1.SisNavBarGroupComponent,
                sis_nav_bar_item_component_1.SisNavBarItemComponent,
                sis_nav_bar_section_component_1.SisNavBarSectionComponent,
                nav_message_pipe_1.NavMessagePipe
            ],
            providers: [
                login_guard_service_1.LoginGuard,
                idm_authorization_client_js_1.PermissionGuard,
                navigation_item_title_handler_service_1.NavigationItemTitleHandlerService,
                { provide: pin_unpin_service_1.PinUnpinService, useClass: pin_unpin_service_impl_1.PinUnpinServiceImpl }
            ]
        })
    ], ShellNavigationBlockModule);
    return ShellNavigationBlockModule;
}());
exports.ShellNavigationBlockModule = ShellNavigationBlockModule;
//# sourceMappingURL=shell.navigation.block.module.js.map